import React from "react";
import { Box, Grid, IconButton, Modal, Typography } from "@mui/material";
import { CloseIcon } from "../assets/images";
import { Field, Formik } from "formik";
import FormikInput from "./FormikInput";
import TableDataGrid from "./TableDataGrid";
import { GridColDef } from "@mui/x-data-grid";
import _ from "lodash";

const TranscriptionDialog = ({
  field: { ...fields },
  ...props
}): React.ReactNode => {
  const { className, ...rest } = props;

  const initialState = {
    S: fields?.value?.soap?.subjective,
    O: fields?.value?.soap?.objective,
    A: fields?.value?.soap?.assessment,
    P: fields?.value?.soap?.plan,
  };

  const iCD10CodesColumns: GridColDef[] = [
    {
      field: "code",
      headerName: "Code",
      align: "left",
      minWidth: 150,
      flex: 1,
      headerAlign: "left",
    },
    {
      field: "desc",
      headerName: "Description",
      minWidth: 170,
      flex: 1,
    },
  ];

  const firstRef = React.useRef(true);

  React.useEffect(() => {
    if (fields?.value) firstRef.current = false;
  }, [fields?.value]);

  return (
    <Modal
      open={props.open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") return; // Prevent closing on backdrop click
        props.handleClose();
      }}
      disableEnforceFocus
    >
      <Box className="modal-box">
        <div className="modal-head">
          <Typography variant="h3" className="modal-title">
            AI Assistant
          </Typography>
          <IconButton
            className="icon-btn btn-close"
            onClick={props.handleClose}
          >
            <img src={CloseIcon} alt="Icon" />
          </IconButton>
        </div>
        <div className="modal-body" style={{ paddingTop: 16 }}>
          <div className="ck-outer">
            <Grid container spacing={2} sx={{ paddingBottom: 2 }}>
              <Grid item xs={12}>
                <Box>
                  <Formik
                    initialValues={initialState}
                    onSubmit={() => console.log()}
                    validateOnBlur={true}
                    validateOnChange={true}
                    enableReinitialize={true}
                  >
                    {(props: { setFieldValue: any; handleSubmit: any }) => {
                      const { setFieldValue, handleSubmit } = props;
                      return (
                        <form onSubmit={handleSubmit} noValidate>
                          <Typography
                            variant="h6"
                            sx={{ color: "#0252E6", paddingBottom: 1 }}
                          >
                            SOAP:
                          </Typography>
                          <Grid container spacing={2}>
                            <Grid item xs={6}>
                              <Field
                                type="text"
                                label="Subjective"
                                name="S"
                                id="S"
                                className="st-textarea"
                                maxLength={10000}
                                rows={5}
                                multiline
                                onChange={(e: any) => {
                                  setFieldValue("S", e?.target?.value);
                                }}
                                component={FormikInput}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Field
                                type="text"
                                label="Objective"
                                name="O"
                                id="O"
                                className="st-textarea"
                                maxLength={10000}
                                rows={5}
                                multiline
                                onChange={(e: any) => {
                                  setFieldValue("O", e?.target?.value);
                                }}
                                component={FormikInput}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Field
                                type="text"
                                label="Assessment"
                                name="A"
                                id="A"
                                className="st-textarea"
                                maxLength={10000}
                                rows={5}
                                multiline
                                onChange={(e: any) => {
                                  setFieldValue("A", e?.target?.value);
                                }}
                                component={FormikInput}
                              />
                            </Grid>
                            <Grid item xs={6}>
                              <Field
                                type="text"
                                label="Plan"
                                name="P"
                                id="P"
                                className="st-textarea"
                                maxLength={10000}
                                rows={5}
                                multiline
                                onChange={(e: any) => {
                                  setFieldValue("P", e?.target?.value);
                                }}
                                component={FormikInput}
                              />
                            </Grid>
                          </Grid>
                        </form>
                      );
                    }}
                  </Formik>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="h5"
                    sx={{ color: "#0252E6", paddingBottom: 1 }}
                  >
                    Suggested Diagnoses with ICD10 Codes:
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TableDataGrid
                        rows={fields?.value?.icD10Codes}
                        totalRecords={fields?.value?.icD10Codes?.length}
                        columns={iCD10CodesColumns}
                        hidePagination
                        rowId={"code"} // uniq key
                      />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>

              <Grid item xs={6}>
                <Box>
                  <Typography
                    variant="h5"
                    sx={{ color: "#0252E6", paddingBottom: 1 }}
                  >
                    Suggested Prescriptions:
                  </Typography>
                  <Box
                    sx={{
                      border: "2px solid hsl(0deg 0% 93.73%)",
                      borderRadius: "8px",
                      margin: 0,
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12}>
                        {fields?.value?.prescriptions &&
                          fields?.value?.prescriptions.map(
                            (value: {
                              prescriptionStr: any;
                              medication: any;
                              dosage: any;
                              frequency: any;
                              duration: any;
                            }, index: number) => {
                              return (
                                <Box
                                  sx={{ padding: 1 }}
                                  key={value?.prescriptionStr}
                                >
                                  {index + 1}: {value?.prescriptionStr}
                                </Box>
                              );
                            }
                          )}
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default TranscriptionDialog;
